import { render, staticRenderFns } from "./DenunciaCamposInserir.vue?vue&type=template&id=56569e94&scoped=true&lang=pug"
import script from "./DenunciaCamposInserir.vue?vue&type=script&lang=js"
export * from "./DenunciaCamposInserir.vue?vue&type=script&lang=js"
import style0 from "./DenunciaCamposInserir.vue?vue&type=style&index=0&id=56569e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56569e94",
  null
  
)

export default component.exports